import { Component } from '@angular/core';

@Component({
    selector: 'eventlog',
    templateUrl: 'event.log.component.html',
    styleUrls: ['event.log.component.scss']

})
export class EventLogComponent {
    constructor() {
    }
}
